import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '../lib/api';

export interface ForecastProject {
  soNumber: string;
  priority: string;
  quantity: number;
}

export interface ForecastItem {
  partNumber: string;
  quantityNeeded: number;
  needByDate: string | null;
  projects: ForecastProject[];
}

export interface ForecastBucket {
  vendorName: string;
  vendorId: string | null;
  weekStart: string;
  weekEnd: string;
  items: ForecastItem[];
  totalParts: number;
  totalQuantity: number;
}

interface ForecastResponse {
  data: ForecastBucket[];
}

export function useForecast(weeks: number = 8) {
  return useQuery({
    queryKey: ['forecast', weeks],
    queryFn: () => apiFetch<ForecastResponse>(`/api/v1/procurement/forecast?weeks=${weeks}`),
    staleTime: 60000,
  });
}
